import { render, staticRenderFns } from "./no-access.vue?vue&type=template&id=4e6d69f5&scoped=true"
var script = {}
import style0 from "./no-access.vue?vue&type=style&index=0&id=4e6d69f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d69f5",
  null
  
)

export default component.exports